export class StorytellerConfigurationError extends Error {
    constructor() {
        super("Storyteller video is unavailable right now.");
        this.name = "StorytellerConfigurationError";
    }
}
export function getStorytellerApiKey(injectedValue = getInjectedValue()) {
    const apiKey = injectedValue?.trim();
    if (!apiKey) {
        throw new StorytellerConfigurationError();
    }
    return apiKey;
}
function getInjectedValue() {
    return typeof __STORYTELLER_API_KEY__ === "string"
        ? __STORYTELLER_API_KEY__
        : undefined;
}
